import React from 'react';
import { Alert } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { isReadOnlyAdmin } from '../../hooks/useReadOnlyMode';

// Persistent banner shown to read-only admins so disabled controls make sense.
const ReadOnlyBanner = () => {
  if (!isReadOnlyAdmin()) return null;
  return (
    <Alert
      severity="info"
      icon={<VisibilityIcon fontSize="small" />}
      sx={{ borderRadius: 0, justifyContent: 'center' }}
    >
      You have <strong>read-only</strong> access to the Prism admin portal. You can view
      everything, but you can't create, edit, or delete resources.
    </Alert>
  );
};

export default ReadOnlyBanner;
